import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Goal from "./Goal";
import Button from "react-bootstrap/esm/Button";
import toast, { Toaster } from "react-hot-toast";
import Col from "react-bootstrap/esm/Col";
function Goals(props) {
  const [guess, setGuess] = useState([]);
  const [attempts, setAttempts] = useState(0);
  const [guessedAnswer, setGuessedAnswer] = useState([]);
  const [passHint, setPassHint] = useState();
  const [hintToggle, setHintToggle] = useState(false);

  const answerCheck = () => {
    if (guess.length === 1) {
      props.setPlay(true);
    }
    if (guess.length > 0 && guess.length === props.letters.length) {
      if (guessedAnswer === props.word) {
        props.setPlay(false);
        toast(
          "Congratulations, you've solved the puzzle. The word was " +
            props.word +
            ".",
          {
            duration: 6000,
            position: "bottom-center",
          }
        );
        props.setTimesPlayed((prevPlayed) => prevPlayed + 1);
      } else {
        toast(
          "It looks like something is incorrect. If you need help use the yellow hint button at the top right corner.",
          {
            duration: 5000,
            position: "bottom-center",
          }
        );
      }
    } else {
    }
  };

  const hint = () => {
    if (guessedAnswer.length > 0) {
      const currentUserGuess = guessedAnswer.split("");
      const correctAnswer = props.word.split("");
      let indexToChange = currentUserGuess.findIndex((letter, x) => {
        return letter !== correctAnswer[x];
      });
      if (indexToChange === -1) {
        indexToChange = currentUserGuess.length;
      }
      setPassHint(correctAnswer[indexToChange]);
    } else {
    }
    setHintToggle(true);
  };

  useEffect(() => {
    answerCheck();
  }, [attempts]);

  return (
    <>
      <Container
        style={{
          width: "100%",
          height: "420px",
          backgroundColor: "rgb(0 75 169 / 42%)",
          borderRadius: "25px",
        }}
      >
        <Row
          style={{
            height: "45px",
            borderBottom: "solid 2px #333",
          }}
        >
          {" "}
          <div style={{ textAlign: "right" }}>
            <Button
              style={{ height: "35px", width: "100px", margin: "5px" }}
              variant="warning"
              onClick={hint}
            >
              Hint?
            </Button>
          </div>
        </Row>
        <Row style={{ height: "350px" }}>
          <div
            style={{
              textAlign: "center",
              fontSize: "30px",
              color: "#004d9d",
            }}
          >
            <b>{props.phrase}...</b>
          </div>
          {props.letters.map((letter, x) => (
            <Col
              style={{
                paddingLeft: "1px",
                paddingRight: "1px",
              }}
              key={letter.id}
            >
              <Goal
                key={letter.id}
                letter={letter.letter}
                setGuess={setGuess}
                guess={guess}
                setAttempts={setAttempts}
                x={x}
                setGuessedAnswer={setGuessedAnswer}
                errorChecking={props.errorChecking}
                word={props.word}
                passHint={passHint}
                hint={hintToggle}
                setHintToggle={setHintToggle}
              />
            </Col>
          ))}
        </Row>
        <Row style={{ height: "25px", borderTop: "solid 2px #333" }}></Row>
        <Toaster />
      </Container>
    </>
  );
}

export default Goals;
